import 'lite-youtube-embed/src/lite-yt-embed.js';
import 'lite-youtube-embed/src/lite-yt-embed.css';
import Accordion from './components/accordion.js';
import Confirm from './components/confirm.js';
import confirmToggles from './components/confirm-toggle.js';
import Drawer from './components/drawer.js';
import newsletter from './components/newsletter.js';
import Overlay from './components/overlay.js';
import './sections/announcement-banner.js';
import './sections/blog-post.js';
import './sections/blog-template.js';
import './sections/cart-modal.js';
import './sections/cart-page.js';
import './sections/featured-blog.js';
import './sections/hero-banner.js';
import './sections/product-carousel.js';
import './sections/promotion-hero-banner.js';
import './sections/site-header.js';
import './sections/tabbed-collections.js';
import './sections/password.js';

document.addEventListener('DOMContentLoaded', () => {
  // Set up accordions
  [...document.querySelectorAll('[data-accordion]')].forEach(
    accordion => new Accordion(accordion)
  );

  newsletter();

  // eslint-disable-next-line no-new
  new Overlay(document.querySelector('[data-overlay]'));

  const $drawers = [...document.querySelectorAll('[data-drawer]')];
  $drawers.forEach($drawer => {
    // eslint-disable-next-line no-new
    new Drawer($drawer);
  });

  const $confirms = document.querySelectorAll('[data-confirm]');
  $confirms.forEach($confirm => {
    // eslint-disable-next-line no-new
    new Confirm($confirm, $confirm.dataset.confirm);
  });

  confirmToggles();

  // Dynamically importing Google Model Viewer
  const $3dProductModel = document.querySelector('.section-3d-product-model');
  if ($3dProductModel) {
    import('@google/model-viewer');
  }
});
